<template>
  <div class="today-flx">
    <div class="today-flx-item" v-for="(elx, idx) in data" :key="idx">
      <h2 class="item-title">
        {{ elx.name }}
      </h2>
      <div class="item-content">
        <p class="today-num" v-for="(item, index) in elx.children" :key="index">
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ item.value }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.today-flx {
  width: 100%;
  padding-bottom: 30px;
  &-item {
    display: flex;
    margin-bottom: 20px;
    .item-title {
      width: 54px;
      height: 136px;
      line-height: 54px;
      text-align: center;
      background: rgba(97, 73, 241, 0.2);
      border-radius: 4px 0px 0px 4px;
      font-size: 14px;
      font-weight: 600;
      color: #444444;
      writing-mode: tb;
      letter-spacing: 5px;
    }
    .item-content {
      display: flex;
      flex-wrap: wrap;
      width: calc(100% - 54px);
      padding: 20px 0;
      border-radius: 0px 4px 4px 0px;
      background: #f7f7f9;
      .today-num {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        flex: 0 0 50%;
        padding: 5px 30px;
        .label {
          margin-right: 40px;
          font-size: 14px;
          color: #444444;
        }
        .value {
          margin-top: -6px;
          font-size: 26px;
          font-weight: 600;
          color: #444444;
        }
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
